"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchConvAiDashboardSettingsRequest = void 0;
var PatchConvAiDashboardSettingsRequest_1 = require("./PatchConvAiDashboardSettingsRequest");
Object.defineProperty(exports, "PatchConvAiDashboardSettingsRequest", { enumerable: true, get: function () { return PatchConvAiDashboardSettingsRequest_1.PatchConvAiDashboardSettingsRequest; } });
